var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _text, _text2, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _text3, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "288 264 240 264 324 222 330 213 330 201 372 222 288 264",
    fill: "#1d1d1b",
    opacity: 0.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "120 198 120 204 240 264 240 258 120 198",
    fill: "#1368ab",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "240 264 324 222 324 216 240 258 240 264",
    fill: "#105890",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "204 156 120 198 240 258 324 216 204 156",
    fill: "#146eb4",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "330 111 324 114 324 222 330 213 330 111",
    fill: "#105890",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "210 51 204 54 324 114 330 111 210 51",
    fill: "#146eb4",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "324 114 204 54 204 156 324 216 324 114",
    fill: "#0a3759",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "208 62 208 152 320 208 320 118 208 62",
    fill: "#5b9acb",
    opacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 215,
    x2: 262,
    y2: 239,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 215,
    x2: 206,
    y2: 163,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 219,
    x2: 198,
    y2: 167,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 294,
    y1: 223,
    x2: 190,
    y2: 171,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 223,
    x2: 182,
    y2: 175,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 231,
    x2: 174,
    y2: 179,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 235,
    x2: 166,
    y2: 183,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 262,
    y1: 239,
    x2: 158,
    y2: 187,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 211,
    x2: 254,
    y2: 235,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 294,
    y1: 207,
    x2: 246,
    y2: 231,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 286,
    y1: 203,
    x2: 238,
    y2: 227,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 199,
    x2: 238,
    y2: 219,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 195,
    x2: 230,
    y2: 215,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 262,
    y1: 191,
    x2: 222,
    y2: 211,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 254,
    y1: 187,
    x2: 214,
    y2: 207,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 246,
    y1: 183,
    x2: 206,
    y2: 203,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 179,
    x2: 198,
    y2: 199,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 175,
    x2: 182,
    y2: 199,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 222,
    y1: 171,
    x2: 174,
    y2: 195,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 214,
    y1: 167,
    x2: 166,
    y2: 191,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 206,
    y1: 163,
    x2: 158,
    y2: 187,
    fill: "none",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "168 300 174 297 174 267 216 288 192 300 168 300",
    fill: "#1d1d1b",
    opacity: 0.2
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "108 330 112 328 112 296 156 318 132 330 108 330",
    fill: "#1d1d1b",
    opacity: 0.2
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "102 129 96 132 168 168 174 165 102 129",
    fill: "#146eb4",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "96 132 96 264 168 300 168 168 96 132",
    fill: "#0a3759",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "174 165 168 168 168 300 174 297 174 165",
    fill: "#105890",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "100 140 100 260 164 292 164 172 100 140",
    fill: "#5b9acb",
    opacity: 0.05
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0.5, 0, 1, 212.1, 73.94)",
    fontSize: 8,
    fill: "#64c8ff",
    fontFamily: "RobotoMono-Bold, Roboto Mono",
    fontWeight: 700
  }, "M/S Yourvessel", /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "220v 60Hz"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "1337 kWh"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0.5, 0, 1, 104.1, 153.94)",
    fontSize: 7,
    fill: "#64c8ff",
    fontFamily: "RobotoMono-Bold, Roboto Mono",
    fontWeight: 700
  }, "M/S Yourvessel", /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "220v"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "60Hz"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "1337 kWh"))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "208 114 220 134 240 124 260 134 280 164 300 186 320 196 320 208 208 152 208 114",
    fill: "#a3d6a6"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "100 208 106.86 219.43 118.29 213.71 129.71 219.43 141.14 236.57 152.57 249.14 164 254.86 164 261.71 100 229.71 100 208",
    fill: "#a3d6a6"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "316 141 300 133 300 127 316 135 316 141",
    fill: "#ff9a7a"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "316 153 300 145 300 139 316 147 316 153",
    fill: "#ffda6a"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "316 165 300 157 300 151 316 159 316 165",
    fill: "#a3d6a6"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "116 253 100 245 100 239 116 247 116 253",
    fill: "#ff9a7a"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "140 265 124 257 124 251 140 259 140 265",
    fill: "#ffda6a"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "164 277 148 269 148 263 164 271 164 277",
    fill: "#a3d6a6"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "76 226 72 228 108 246 112 244 76 226",
    fill: "#146eb4",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "72 228 72 312 108 330 108 246 72 228",
    fill: "#0a3759",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "112 244 108 246 108 330 112 328 112 244",
    fill: "#105890",
    stroke: "#64c8ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "76 236 76 308 104 322 104 250 76 236",
    fill: "#5b9acb",
    opacity: 0.05
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "84 298 76 294 76 290 84 294 84 298",
    fill: "#64c8ff"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "94 303 86 299 86 295 94 299 94 303",
    fill: "#64c8ff"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "80 290 76 288 76 284 80 286 80 290",
    fill: "#64c8ff"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "104 316 96 312 96 308 104 312 104 316",
    fill: "#a3d6a6"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "94 311 86 307 86 303 94 307 94 311",
    fill: "#ffda6a"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "84 306 76 302 76 298 84 302 84 306",
    fill: "#ff9a7a"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "104 302 82 291 82 287 104 298 104 302",
    fill: "#64c8ff"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "76 261 79 268 84 266 89 268 94 277 99 282 104 284.5 104 291.5 76 277.5 76 261",
    fill: "#a3d6a6"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0.5, 0, 1, 76.1, 238.94)",
    fontSize: 4.2,
    fill: "#64c8ff",
    fontFamily: "RobotoMono-Bold, Roboto Mono",
    fontWeight: 700
  }, "Shore power")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "204 114 204 138 288 96 264 84 204 114",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "204 102 204 108 258 81 252 78 204 102",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "96 192 96 216 168 180 168 168 156 162 96 192",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "96 180 96 186 150 159 144 156 96 180",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "72 276 72 300 108 282 108 258 72 276",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "72 264 72 270 108 252 108 246 72 264",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide3);
export default __webpack_public_path__ + "static/media/Slide3.1ebcf63b57b42961fa8347289ece1b18.svg";
export { ForwardRef as ReactComponent };